import InboxIcon from '@mui/icons-material/Inbox';
import {
  MenuCounterNotifications,
  MenuCounterNotificationText,
  MenuNoNotifications,
  MenuNotificationBody,
  MenuNotificationContainer,
  MenuNotificationContent,
  MenuNotificationIcon,
  MenuNotificationItem,
  MenuNotificationTime,
  MenuNotificationTitle,
} from './style';
import { Chip } from '@mui/material';
import { formatDateTimeToDateTimeBR } from 'utils/date_utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const MenuNotifications = ({ notifications, showMenu, totalNotifications }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  return (
    <MenuNotificationContainer className={showMenu ? 'show' : ''}>
      <MenuCounterNotifications>
        <MenuCounterNotificationText>
          {t('header.notificationsCount', { count: totalNotifications })}
        </MenuCounterNotificationText>
      </MenuCounterNotifications>
      {notifications?.map((notification, index) => (
        <MenuNotificationItem key={notification._id || index}>
          <MenuNotificationIcon>
            <InboxIcon />
          </MenuNotificationIcon>
          <MenuNotificationBody>
            <MenuNotificationTitle>{notification.titleNotification}</MenuNotificationTitle>
            <MenuNotificationContent>{notification.bodyNotification}</MenuNotificationContent>
            <MenuNotificationTime>{formatDateTimeToDateTimeBR(notification.createdDate, true)}</MenuNotificationTime>
          </MenuNotificationBody>
        </MenuNotificationItem>
      ))}
      {(!notifications || notifications?.length === 0) && (
        <MenuNoNotifications>
          <MenuCounterNotificationText>{t('header.noNotifications')}</MenuCounterNotificationText>
        </MenuNoNotifications>
      )}
      {notifications && notifications?.length > 0 && (
        <MenuNoNotifications>
          <Chip
            label={t('header.viewAll')}
            color="primary"
            size="small"
            onClick={() => {
              navigate('/user-notifications');
            }}
          />
        </MenuNoNotifications>
      )}
    </MenuNotificationContainer>
  );
};
